import styled from "styled-components";
const PolicyInfoWrapper = styled.div`
    z-index: 9999

 .container-fluid {
  max-width: 400px;
 }
 .popup_action_btn {
  width: fit-content;
  margin: auto;
  background: #6B47F5;
  padding: 5px 1rem;
  border-radius: 5px;
  cursor: pointer;

  p {
   margin-bottom: 0px;
   color: #ffffff;
  }
 }
 @media only screen and (max-width: 576px) {
  .container-fluid {
   max-width: 300px;
  }
 }
`;
export default PolicyInfoWrapper;
